import React from 'react';

import { GroupAvatars } from './js/icons/GroupAvatars';
import { BarChartUp } from './js/icons/BarChartUp';
import { VennDiagram3 } from './js/icons/VennDiagram3';

export const screenMaxSizes = {
  mobile: 767,
  tablet: 1279, 
}

export const personalInfo = {
  firstName: 'Curtis',
  lastName: 'Lefrandt',
}

export const navbar = {
  links: [
    {
      type: "link",
      text: "about us",
      target: "/about-us",
    },
    {
      type: "link",
      text: "services",
      target: "/services",
    },
    {
      type: "link",
      text: "resources",
      target: "/resources",
    },
    {
      type: "link",
      text: "contact",
      target: "/contact",
    },
  ]
}

export const homePage = {
  bannerImages: [
    {
      imageSrc: 'images/background/bike-race.jpeg',
      text: 'committed.',
    },
    {
      imageSrc: 'images/background/biker-behind.jpeg',
      text: 'committed.',
    },
    {
      imageSrc: 'images/background/biker-front.jpeg',
      text: 'committed.',
    },
    {
      imageSrc: 'images/background/family-beach.jpeg',
      text: 'peace.',
    },
    {
      imageSrc: 'images/background/family-couch.jpeg',
      text: 'purpose.',
    },
    {
      imageSrc: 'images/background/mountain-climber.jpeg',
      text: 'balance.',
    },
    {
      imageSrc: 'images/background/mountains.jpeg',
      text: 'life elevated.',
    },
    {
      imageSrc: 'images/background/rock-climber.jpeg',
      text: 'committed.',
    },
  ]
}

export const homePageContent = [
  {
    icon: <img className="content-section-img" alt="" src="images/icons/teamwork.png" />,
    header: "Who we are...",
    text: "Have you ever had an idea that you thought would change the world, only to realize you don't have enough resources to make it happen? Our BIG IDEA at The Round Table Solution is to give you the gift of more.... time, resources, controle, expertise.",
    url: "/about-us",
  },
  {
    icon: <img className="content-section-img" alt="" src="images/icons/bar-chart.png" />,
    header: "What we do...",
    text: "We streamline the administration of your organization so you can focus on your BIG, BOLD idea with confidence. Our services ensure that the data you need to monitor and measure success is available, accurate, and understandable.",
    url: "/services",
  },
  {
    icon: <VennDiagram3/>,
    header: "How we share...",
    text: "We love information! After we get done with our jobs, we go bak to work for fun! We belive that useful information is part of the “rising tide that lifts all boats.”",
    url: "/about",
  },
]

export const teamMembers = [
  {
    name: 'Harry Potter',
    position: 'Chosen One / Quidditch Legend',
    image: 'https://vignette.wikia.nocookie.net/harrypotter/images/d/d9/OOTP_promo_front_Harry_Potter.jpg/revision/latest?cb=20150104000646',
    bio: `Harry James Potter was an English half-blood wizard, one of the most famous wizards of modern times. He was the only child and son of James and Lily Potter, both members of the original Order of the Phoenix.`,
    socialMedia: [
      {
        name: 'instagram',
        url: 'https://www.instagram.com/harrypotterfilm/?hl=en',
      },
      {
        name: 'linkedin',
        url: 'https://harrypotter.fandom.com/wiki/Harry_Potter',
      },
      {
        name: 'twitter',
        url: 'https://twitter.com/hashtag/harrypotter?lang=en'
      },
    ]
  },
  {
    name: 'Tom Riddle',
    position: 'Dark Lord / Avid Collector',
    image: 'https://static1.squarespace.com/static/5a5d268364b05f7a0f038afe/t/5b50d55e575d1fb57bf0e109/1532024469115/Voldemort.jpg?format=1500w',
    bio: `Tom Marvolo Riddle, later known as Lord Voldemort or alternatively as You-Know-Who, He-Who-Must-Not-Be-Named, or the Dark Lord, was an English half-blood wizard considered to have been the most powerful and dangerous Dark Wizard of all time.`,
    socialMedia: [
      {
        name: 'linkedin',
        url: 'https://harrypotter.fandom.com/wiki/Tom_Riddle',
      },
      {
        name: 'twitter',
        url: 'https://twitter.com/hashtag/harrypotter?lang=en'
      },
    ]
  },
  {
    name: 'Albus Dumbledore',
    position: 'Hogwarts Headmaster',
    image: 'https://vignette.wikia.nocookie.net/harrypotter/images/4/40/Albus_Dumbledore_%28HBP_promo%29_3.jpg/revision/latest?cb=20150822232849',
    bio: `Professor Albus Percival Wulfric Brian Dumbledore, O.M. (First Class), Grand Sorc., D. Wiz., X.J., S. of Mag.Q. was an English half-blood wizard, who was the Defence Against the Dark Arts Professor, later the Transfiguration Professor, and later Headmaster of Hogwarts School of Witchcraft and Wizardry.`,
    socialMedia: [
      {
        name: 'linkedin',
        url: 'https://harrypotter.fandom.com/wiki/Albus_Dumbledore',
      },
      {
        name: 'twitter',
        url: 'https://twitter.com/hashtag/harrypotter?lang=en'
      },
    ]
  },
  {
    name: 'Matt',
    position: 'Radar Technician',
    image: 'https://www.cheatsheet.com/wp-content/uploads/2019/09/Adam-Driver-SNL.jpg',
    bio: `A dark warrior strong with the Force, Kylo Ren commands First Order missions with a temper as fiery as his unconventional lightsaber. As a leader of the First Order and a student of Supreme Leader Snoke, he seeks to destroy the New Republic, the Resistance and the legacy of the Jedi.`,
  },
  {
    name: 'Hermione Granger',
    position: 'Minister for Magic',
    image: 'https://buddybits.com/wp-content/uploads/2016/11/10-Reasons-Why-We-Love-Hermione-Granger-768x514.jpg',
    bio: `Hermione Jean Granger (b. 19 September, 1979[1]) was an English Muggle-born witch born to Mr and Mrs Granger. At the age of eleven, she learned about her magical nature and was accepted into Hogwarts School of Witchcraft and Wizardry.`,
    socialMedia: [
      {
        name: 'linkedin',
        url: 'https://harrypotter.fandom.com/wiki/Hermione_Granger',
      },
      {
        name: 'twitter',
        url: 'https://twitter.com/hashtag/harrypotter?lang=en'
      },
    ]
  },
  {
    name: 'Severus Snape',
    position: 'Potions Master / Head of Slytherin House',
    image: 'https://upload.wikimedia.org/wikipedia/en/thumb/b/b9/Ootp076.jpg/220px-Ootp076.jpg',
    bio: `Severus Snape was an English half-blood wizard serving as Potions Master (1981-1996), Defence Against the Dark Arts professor (1996-1997), and Headmaster (1997-1998) of the Hogwarts School of Witchcraft and Wizardry as well as a member of the Order of the Phoenix and a Death Eater.`,
    socialMedia: [
      {
        name: 'linkedin',
        url: 'https://harrypotter.fandom.com/wiki/Severus_Snape',
      },
      {
        name: 'twitter',
        url: 'https://twitter.com/hashtag/harrypotter?lang=en'
      },
    ]
  },
]

export const servicesPage = {
  header: "Chase Your Dream",
  headerText: [
    "Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus. Proin eget tortor risus. Praesent sapien massa, convallis a pellentesque nec, egestas non nisi. Cras ultricies ligula sed magna dictum porta. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus. Proin eget tortor risus. Praesent sapien massa, convallis a pellentesque nec, egestas non nisi. Cras ultricies ligula sed magna dictum porta.",
    "Praesent sapien massa, convallis a pellentesque nec, egestas non nisi. Praesent sapien massa, convallis a pellentesque nec, egestas non nisi."
  ],
  services: [
    {
      name: "accounting",
      image: "accounting-person-calculator.jpeg",
      description: "Donec sollicitudin molestie malesuada. Pellentesque in ipsum id orci porta dapibus. Nulla quis lorem ut libero malesuada feugiat. Vivamus suscipit tortor eget felis porttitor volutpat. Donec sollicitudin molestie malesuada. Pellentesque in ipsum id orci porta dapibus. Nulla quis lorem ut libero malesuada feugiat. Vivam",
      link: "/services/accounting",
    },
    {
      name: "information",
      image: "ipad-papers.jpeg",
      description: "Donec sollicitudin molestie malesuada. Pellentesque in ipsum id orci porta dapibus. Nulla quis lorem ut libero malesuada feugiat. Vivamus suscipit tortor eget felis porttitor volutpat. Donec sollicitudin molestie malesuada. Pellentesque in ipsum id orci porta dapibus. Nulla quis lorem ut libero malesuada feugiat. Vivamus suscipit tortor eget felis porttitor volutpat. Donec sollicitudin molestie malesuada. Pellentesque in ipsum id orci porta dapibus. Nulla quis lorem ut libero malesuada feugiat. Vivamus suscipit tortor eget felis porttitor volutpat.",
      link: "/services/information",
    },
    {
      name: "cooking",
      image: "need-help-papers.jpeg",
      description: "Donec sollicitudin molestie malesuada. Pellentesque in ipsum id orci porta dapibus. Nulla quis lorem ut libero malesuada feugiat. Vivamus suscipit tortor eget felis porttitor volutpat. Donec sollicitudin molestie malesuada. Pellentesque in ipsum id orci porta dapibus. Nulla quis lorem ut libero malesuada feugiat. Vivamus suscipit tortor eget felis porttitor volutpat. Donec sollicitudin molestie malesuada. Pellentesque in ipsum id pat.",
      link: "/services/cooking",
    },
    {
      name: "marathon running",
      image: "blue-suit-icons.jpeg",
      description: "Donec sollicitudin molestie malesuada. Pellentesque in ipsum id orci porta dapibus. Nulla quis lorem ut libero malesuada feugiat. Vivamus suscipit tortor eget felis porttitor volutpat. Donec sollicitudin molestie malesuada. Pellentesque in ipsum id orci porta dapibus.",
      link: "/services/marathon-running",
    },
  ]
}
